import { apiMockSwitcher } from 'APIPackage/MainModule/mock/apiMockSwitcher';

import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';
import { handleResponse } from '../../MainModule/common/handleResponse';
import { IJudgmentCourt } from '../interfaces/IJudgmentCourt';
import { IJudgmentPunishmentType } from '../interfaces/IJudgmentPunishmentType';
import { IJudgmentPunishmentIndex } from '../interfaces/IJudgmentPunishmentIndex';
import { IJudgmentProsecutionType } from '../interfaces/IJudgmentProsecutionType';
import { IJudgmentKind } from '../interfaces/IJudgmentKind';
import { IJudgmentCourtLevel } from '../interfaces/IJudgmentCourtLevel';
import { IJudgmentCancellationInfo } from '../interfaces/IJudgmentCancellationInfo';

export async function fetchJudgmentEnabledCourts(): Promise<IJudgmentCourt[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/judgment/enabled-courts`;
  const mockData = apiMockSwitcher(url, 'GET');

  if (process.env.REACT_APP_LOCAL_MODE === '1' && mockData) {
    return mockData as IJudgmentCourt[];
  }

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}

export async function fetchCreateCourt(court: IJudgmentCourt): Promise<IJudgmentCourt> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/judgment/court`;
  const mockData = apiMockSwitcher(url, 'GET');

  if (process.env.REACT_APP_LOCAL_MODE === '1' && mockData) {
    return mockData as IJudgmentCourt;
  }

  return fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(court),
  }).then(handleResponse);
}

export async function fetchJudgmentCourtLevels(): Promise<IJudgmentCourtLevel[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/judgment/all-court-levels`;
  const mockData = apiMockSwitcher(url, 'GET');

  if (process.env.REACT_APP_LOCAL_MODE === '1' && mockData) {
    return mockData as IJudgmentCourtLevel[];
  }

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}

export async function fetchJudgmentKinds(): Promise<IJudgmentKind[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/judgment/all-judgment-kinds`;
  const mockData = apiMockSwitcher(url, 'GET');

  if (process.env.REACT_APP_LOCAL_MODE === '1' && mockData) {
    return mockData as IJudgmentKind[];
  }

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}

export async function fetchJudgmentProsecutionTypes(): Promise<IJudgmentProsecutionType[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/judgment/all-prosecution-types`;
  const mockData = apiMockSwitcher(url, 'GET');

  if (process.env.REACT_APP_LOCAL_MODE === '1' && mockData) {
    return mockData as IJudgmentProsecutionType[];
  }

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}

export async function fetchJudgmentPunishmentTypes(): Promise<IJudgmentPunishmentType[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/judgment/all-punishment-types`;
  const mockData = apiMockSwitcher(url, 'GET');

  if (process.env.REACT_APP_LOCAL_MODE === '1' && mockData) {
    return mockData as IJudgmentPunishmentType[];
  }

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}

export async function fetchJudgmentPunishmentIndex(): Promise<IJudgmentPunishmentIndex[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/judgment/all-punishment-index`;
  const mockData = apiMockSwitcher(url, 'GET');

  if (process.env.REACT_APP_LOCAL_MODE === '1' && mockData) {
    return mockData as IJudgmentPunishmentIndex[];
  }

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}

export async function fetchJudgmentCancellationInfo(): Promise<IJudgmentCancellationInfo[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/judgment/all-cancellation-information`;
  const mockData = apiMockSwitcher<IJudgmentCancellationInfo[]>(url, 'GET');

  if (mockData) return mockData;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}
